@if (authSvc.hasSession()) {
  <div class="credentials">
    <p class="header" [class.with-prf]="authSvc.prf">
      @if (authSvc.prf) {
        <a
          class="prf-badge"
          [routerLink]="'/help/faqs/2f8'"
          target="_blank"
          aria-label="Local key creation"
          matTooltip="This account uses local key creation">
          <mat-icon class="filled">verified_user</mat-icon>
        </a>
      }
      Passkeys for:
      <button
        class="refresh"
        mat-icon-button
        cdkFocusInitial
        aria-label="Refresh"
        (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
      <br />
      <app-editable
        class="username"
        minlength="6"
        maxlength="31"
        [value]="userName()"
        (valueEdited)="clearError()"
        (valueChanged)="onUserNameChanged($event)">
      </app-editable>
    </p>

    <div class="credtable-wrapper">
      <table mat-table [dataSource]="passKeys()" class="credtable">
        <ng-container matColumnDef="image">
          <td
            mat-cell
            class="tdcommon"
            [class.current-pk]="isCurrentPk(element.credentialId)"
            *matCellDef="let element">
            <img
              src="{{ element.lightIcon }}"
              alt="{{ element.name }}"
              matTooltip="{{ element.name }}"
              class="cred-img" />
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <td
            mat-cell
            class="tdcommon tddescription"
            [class.current-pk]="isCurrentPk(element.credentialId)"
            *matCellDef="let element">
            <app-editable
              class="editable"
              minlength="6"
              maxlength="42"
              [value]="element.description"
              (valueEdited)="clearError()"
              (valueChanged)="onDescriptionChanged($event, element)">
            </app-editable>
            <!--                <input type="text" matInput [value]="element.description" />-->
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <td
            mat-cell
            class="tdcommon"
            [class.current-pk]="isCurrentPk(element.credentialId)"
            *matCellDef="let element">
            <button
              class=""
              (click)="onClickDelete(element)"
              matSuffix
              mat-icon-button
              aria-label="Delete">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <button
      mat-raised-button
      class="add-passkey"
      (click)="onClickAdd()">
      <mat-icon>add</mat-icon>New Passkey
    </button>

    <div class="error-msg">
      @for (part of error(); track $index) {
        @if (part.routerLink) {
          <a [routerLink]="part.routerLink" target="_blank">{{ part.text }}</a>
        } @else {
          {{ part.text }}
        }
      }
    </div>

    <span class="cred-spacer"></span>
    @if (!authSvc.hasRecoveryId()) {
      <mat-card class="old-recovery" appearance="outlined">
        <mat-card-header>
          <mat-card-title>⚠️ Attention</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>
            Your account is using the old recovery mechanism. Click the Account
            Backup button below to update.
          </p>
        </mat-card-content>
      </mat-card>
    }

    <a [routerLink]="'/regenrecovery'">
      <button
        mat-raised-button
        class="endbutton"
        aria-label="Replace recovery words">
        <mat-icon>settings_backup_restore</mat-icon>Account Backup
      </button>
    </a>

    <button
      mat-raised-button
      class="endbutton strong-button"
      aria-label="Sign out"
      (click)="onClickSignout()">
      <mat-icon>logout</mat-icon>Sign Out
    </button>
  </div>
}
